import React, {useState} from 'react'
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {openAlert} from '../../slices/alert';
import {closeDialog} from '../../slices/dialog';
import {selectEmail} from '../../slices/auth';
import {sendMessage} from '../../api/company';
import Button from '../Common/Button';

export const MessageToFollowers = ({emails}) => {
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            message: "",
        }
    });
    const dispatch = useDispatch();
    const email = useSelector(selectEmail);
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();

    const onSave = (form) => {
        if (!email) return;
        setLoading(true);
        sendMessage(emails, form.message, email)
            .then(() => {
                dispatch(openAlert({type: "success", message: t("alert_msg_sent")}))
                dispatch(closeDialog());
                setLoading(false);
            })
            .catch(() => {
                dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
                setLoading(false);
            })
    }

    return (
        <div className="messageToFollowers">
            <form onSubmit={handleSubmit(onSave)}>
                <fieldset disabled={loading}>
                    <div className="element">
                        <div className="label">{t("company_rm_analytics_sendMsg_msg_label")}</div>
                        <textarea
                            name="message"
                            placeholder={t("company_rm_analytics_sendMsg_msg_ph")}
                            ref={register({required: true})}
                            rows="10"
                        />
                        {errors.message && <span className="error">{t("company_rm_analytics_sendMsg_msg_error")}</span>}
                    </div>
                    <Button type="submit" loading={loading}>{t("company_rm_analytics_sendMsg_submit")}</Button>
                </fieldset>
            </form>
        </div>
    )
}
